module.exports = __webpack_public_path__ + "img/1480744248.bbcdae43.jpg";